



























import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";



@Component
export default class BaseTLContextMenu extends Vue {
	@Prop({ type: String, required: false, default: "" }) refer?: string; //reference

	@Prop({ type: String, required: false, default: "" }) label?: string; //hlavní popis
	@Prop({ type: String, required: false, default: "" }) forinput?: string; //pro koho je to popisek
	@Prop({ type: String, required: false, default: "sm" }) size?: string; //velikost pisma sm, lg
	@Prop({ type: String, required: false, default: "left" }) align?: string; //zarovnání 
	@Prop({ type: String, required: false, default: "2" }) labelcols?: string; //počet řádků - velikost 
	@Prop({ type: String, required: false, default: "" }) breakpoint?: string; //hl avní popis
	@Prop({ type: Boolean, required: false, default: false }) isBig?: boolean; //větší pismo

	//načtení stylu
	get inputClass() {
		return {

			"label-design-head": true,
			"label-design-head-bigger": this.isBig
		};
	}

	open( target : any,  cm: any) {
	}

	close(target: any, cm: any) {
	}


}
